module.exports = __webpack_public_path__ + "static/06-b2f6dc2c9f967c3d1abf806ad76df973.png";